export default "__VITE_ASSET__6Q37WQBE__"